
export default [
  {
    path: '/admin/loan-types',
    name: 'loan-type',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-operation/loan-type')
  }
]
